module.exports = __webpack_public_path__ + "media/honey-icons/icon-battery-quarter-8ce38d63.svg";